import { Button } from '@/components/ui/button';
import { trackError } from '@/lib/error-tracking';
import { useState } from 'react';

interface CopyButtonProps {
  value: string;
  // What is being copied, for people who do not see the row it sits in.
  label: string;
}

const COPIED_FOR_MS = 1500;

const CopyButton = ({ value, label }: CopyButtonProps) => {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      window.setTimeout(() => setCopied(false), COPIED_FOR_MS);
    } catch (error) {
      trackError('Could not copy to the clipboard', error);
    }
  };

  return (
    <Button type="button" variant="outline" size="sm" onClick={copy} aria-label={`Copy ${label}`}>
      <span aria-live="polite">{copied ? 'Copied' : 'Copy'}</span>
    </Button>
  );
};

export default CopyButton;
